import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Usuario/deleteUsuarioSeleccion`, method: 'POST', body: list, token: token})
}
